/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiPrimaryRequestPayloadFromJSON, ApiPrimaryRequestPayloadToJSON, } from './ApiPrimaryRequestPayload';
export function ApiGenerateChartResponseFromJSON(json) {
    return ApiGenerateChartResponseFromJSONTyped(json, false);
}
export function ApiGenerateChartResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'chart': !exists(json, 'chart') ? undefined : ApiPrimaryRequestPayloadFromJSON(json['chart']),
    };
}
export function ApiGenerateChartResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'chart': ApiPrimaryRequestPayloadToJSON(value.chart),
    };
}
